module.exports = __webpack_public_path__ + "img/sms-email.8ae26c21.svg";